function useDisableBack() {
  window.history.pushState(null, "", window.location.href);
}

export default useDisableBack;
